try {
  module.exports = require('sha3').SHA3Hash
} catch (err) {
  module.exports = require('./browser')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/keccakjs/index.js
// module id = 47
// module chunks = 0